<template>
  <CallDialog
    v-model="show"
    title="Call in progress"
    :contact="callStore.outgoingCallContact"
    :show-duration="true"
    @close="callStore.endOutgoingCall()"
  >
    <template #buttons>
      <CallButtons
        :muted="callStore.outgoingCallMuted"
        @end-call="callStore.endOutgoingCall()"
        @toggle-mute="callStore.toggleMuteOutgoingCall()"
      />
    </template>
  </CallDialog>
</template>

<script setup>
const callStore = useCallStore()
const show = computed(() => !!callStore.outgoingCall)
</script>
